import api from "./axios";

export async function getAIUsageOverview(params = {}) {
  const response = await api.get("/platform/ai-usage/overview", { params });
  return response.data;
}
export async function getAIUsageDaily(params = {}) {
  const response = await api.get("/platform/ai-usage/daily", { params });
  return response.data;
}
export async function getAIUsageBreakdown(params = {}) {
  const response = await api.get("/platform/ai-usage/breakdown", { params });
  return response.data;
}
export async function listAIUsageOperations(params = {}) {
  const response = await api.get("/platform/ai-usage/operations", { params });
  return response.data;
}
export async function listAIUsageEvents(params = {}) {
  const response = await api.get("/platform/ai-usage/events", { params });
  return response.data;
}
export async function getAIUsageFilters() {
  const response = await api.get("/platform/ai-usage/filters");
  return response.data;
}
export async function listAIModelPrices() {
  const response = await api.get("/platform/ai-usage/prices");
  return response.data;
}
